/**
 * 주어진 URL이 route에 해당하는지 확인합니다.
 * ex) matchPath('/vpc/vpcs/abcd', '/vpc/vpcs/:vpcId') // true
 */
export function matchPath(pathname: string, route: string) {
  const splitPathname = pathname.split('/');
  const splitRoute = route.split('/');

  const pathnameLength = splitPathname.length;

  if (pathnameLength !== splitRoute.length) {
    return false;
  }

  for (let i = 0; i < pathnameLength; i++) {
    const pathnameSegment = splitPathname[i] || '';
    const routeSegment = splitRoute[i] || '';
    const isDynamicRoutePath =
      routeSegment.startsWith(':') || (routeSegment.startsWith('[') && routeSegment.endsWith(']'));
    if (isDynamicRoutePath) {
      continue;
    } else if (pathnameSegment !== routeSegment) {
      return false;
    }
  }

  return true;
}
